query MasterTemplateDownloadUrl($masterTemplateId: ID!) {
    masterTemplateDownloadUrl(masterTemplateId: $masterTemplateId)
}
